<template>
  <div>
    <vx-card class="">
      <div>
        <h1 class="text-lg form-control-label">Add Categories</h1>
        <div class="mb-4 flex items-center w-full">
          <div class="w-1/2 pr-2">
            <label class="col-form-label form-control-label"
              >Category Name</label
            >

            <base-input
              name="Name"
              v-model="name"
              placeholder="Enter Category Name"
              class="cust-mb0"
            ></base-input>
            <span v-if="nameErr" class="small text-danger">{{ msg.name }}</span>
          </div>
          <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label"
              >Category Icon</label
            >

            <b-form>
              <b-form-file
                @change="filesChange"
                v-model="image"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
                accept=".jpg,.png,.webp,.jpeg"
              ></b-form-file>
              <span v-if="!imageErr" class="small text-danger">{{
                msg.image
              }}</span>
            </b-form>
          </div>
        </div>

        <div class="mb-4 flex w-full">
          <div class="w-1/2 pr-2">
            <label class="col-form-label form-control-label">Description</label>

            <!-- <textarea
              v-model="description"
              class="form-control"
              placeholder="Enter details about the course"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea> -->
            <quill-editor
              v-model="description"
              :options="editorOption"
              class="quill-h200px my-2"
              placeholder="Enter details about the course"
            />
            <span v-if="descErr" class="small text-danger">{{ msg.desc }}</span>
          </div>
        </div>

        <!-- <div class="mb-4 flex w-full">
          <div class="w-2/3">
            <div class="mb-4">
              <label class=" col-form-label form-control-label"
                >Author Name</label
              >
              <div
                class="flex mb-2 pr-2"
                v-for="(answer, index) in Answers"
                :key="index"
              >
                <b-input
                  :placeholder="`Author Name ${index + 1}`"
                  class="form-control-muted"
                  v-model="Answers[index]"
                  @focus="AddNewAnswer(index)"
                />
                <base-button
                  size="base"
                  type="primary"
                  @click="DeleteAnswer(index)"
                  >Delete</base-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="mb-4 flex w-full">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >About the course</label
            >

            <textarea
              class="form-control"
              placeholder="Enter details about the course"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </div>
          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Upload Image (About the course)</label
            >

            <b-form>
              <b-form-file
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div>
        </div>
        <div class="mb-4 flex w-full">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Course Content</label
            >

            <textarea
              class="form-control"
              placeholder="Enter Course Content"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </div>
          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Upload Image (Course Content)</label
            >

            <b-form>
              <b-form-file
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div>
        </div>
        <div class="mb-4 flex w-full">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Who this course is for</label
            >

            <textarea
              class="form-control"
              placeholder="Enter Who this course is for"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </div>
          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Upload Image (Who this course is for)</label
            >

            <b-form>
              <b-form-file
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div>
        </div>
        <div class="w-full flex">
          <div class="w-1/2 pr-2 ">
            <label class=" col-form-label form-control-label"
              >Course Reader Level</label
            >
            <base-input class="">
              <select class="form-control ">
                <option> Beginners </option>
                <option> Medium </option>

                <option> High </option>
              </select>
            </base-input>
          </div>
          <div class="w-1/2 pl-2 ">
            <label class=" col-form-label form-control-label"
              >Course Language</label
            >
            <base-input class="">
              <select class="form-control ">
                <option> Select </option>
                <option> English </option>

                <option> Hindi </option>
                <option> Marathi </option>
                <option> Tamil </option>
                <option> Spanish </option>
              </select>
            </base-input>
          </div>
        </div>
        <div class="flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Actual Rate (In INR)</label
            >

            <base-input
              placeholder="Enter Actual Rate"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Discounted Rate (in INR)</label
            >

            <base-input
              placeholder="Enter Discounted Rate"
              class="mb-0"
            ></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2 ">
            <label class=" col-form-label form-control-label"
              >Course Categories</label
            >
            <base-input class="">
              <select class="form-control ">
                <option> Science</option>
                <option> Arts </option>
                <option> Technology</option>
                <option> Sales </option>
                <option> Finacials </option>
              </select>
            </base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Total Hours
            </label>

            <base-input
              placeholder="Enter Total Hours"
              class="mb-0"
            ></base-input>
          </div>
        </div> -->
        <div class="mb-4 pt-4 flex items-center">
          <!-- <base-button icon type="success" class="ml-2">
            <span class="btn-inner--text flex"
              ><feather-icon icon="PlusIcon" class="pr-2"></feather-icon>Create
              Course</span
            >
          </base-button> -->
          <base-button
            @click="addCategory(name, image)"
            icon
            type="primary"
            class="mr-2"
          >
            <span class="btn-inner--text">Create</span>
          </base-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import "../../../scss/Index.scss";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import _ from "lodash";
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      showPlan: false,
      text: "",
      image: "",
      name: "",
      description: "",
      Answers: ["", ""],
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      nameErr: false,
      descErr: false,
      msg: {
        image: "",
        name: "",
        desc: "",
      },
    };
  },
  props: {
    toggleEditModal: Function,
  },
  watch: {
    text(val) {
      this.$store.commit("posts/SET_POST", { key: "Text", value: val });
    },
    Answers(val) {
      this.$store.commit("posts/SET_POST", { key: "Answers", value: val });
    },
  },
  methods: {
    filesChange(event) {
      // console.log(this.icone);
      let mByte = 5 * 1048576;
      if (event.target.files[0].size > mByte) {
        this.icone = null;
        event = {};
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.imageErr = false;
        this.msg.image = "File size exceeds the allowed limit!";
        // return;
      } else {
        this.imageErr = true;
        if (!event.target.files[0].type.includes("image")) {
          this.icone = null;
          event = {};
          this.imageErr = false;
          this.msg.image = "Upload Image Only";
        } else {
          this.imageErr = true;
          this.icone = event.target.files[0];
        }
      }
      // this.imageErr = true;
      // console.log(this.imageErr);
      // if (event.target.files[0].type.includes("video")) {
      //   this.imageErr = true;
      //   this.msg.image = "Upload Image Only";
      // } else {
      //   this.imageErr = false;
      //   this.image = event.target.files[0];
      // }
    },
    handleBack() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "home");
    },
    handleChooseChannel() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "Choose Channel");
    },
    AddNewAnswer(index) {
      if (this.Answers.length - 1 == index) {
        this.Answers.push("");
      }
    },
    DeleteAnswer(index) {
      if ([0, 1].includes(index)) {
        return;
      }
      this.Answers = this.Answers.filter((el, ind) => ind !== index);
    },
    async addCategory(name, image) {
      if (this.name.trim() == "") {
        this.nameErr = true;
        this.msg.name = "Field is required";
        return;
      } else {
        this.nameErr = false;
      }
      // console.log(this.image);
      if (this.image.length !== 0) {
        if (!this.image.type.includes("image")) {
          this.imageErr = false;
          this.msg.image = "Should be an Image";
          return;
        }
      } else {
        this.imageErr = false;
        this.msg.image = "Icon is required";
        return;
      }
      if (this.description.trim() == "") {
        this.descErr = true;
        this.msg.desc = "Field is required";
        return;
      } else {
        this.descErr = false;
      }
      this.descErr = false;
      this.imageErr = true;
      this.nameErr = false;

      let payload = new FormData();
      payload.append("name", this.name);
      payload.append("image", this.image);
      payload.append("description", this.description);
      let loader = this.$loading();

      try {
        // this.$store.commit("eLearning/createCategories",name)
        const { data } = await this.$store.dispatch(
          "eLearning/createCategories",
          payload
        );
        this.$swal.fire({
          title: "Created",
          text: "Course Category has been Created Successfully!",
          icon: "success",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        this.toggleEditModal();
      } catch (error) {
        loader.close();
      }
    },
  },

  computed: {
    ...mapState("posts", {
      currentPage: "currentPage",
      type: "type",
    }),
    title() {
      return this.type.toUpperCase();
    },
  },
};
</script>
